import { getCatalogWithCategories } from "../../modules/dynamic-api-test/catalog/getCatalogWithCategories.js";
/**
 * @typedef {{
*      name: string,
*      morning: {
*          title: string,
*          categories: {
*              [key: string]: {id:number, products: Product[]}
*          }
*      },
*      evening: {
*          title: string,
*          categories: {
*              [key: string]: {id:number, products: Product[]}
*          }
*      },
*      all: {
*          title: string,
*          categories: {
*              [key: string]: {id:number, products: Product[]}
*          }
*      }
* }} AdaptedTestResultWithCategories
*/

/**
 *
 * @param {AdaptedTestResultWithCategories} catalog
 * @returns
 */
export function getCatalogHTML(catalog) {
    const section = document.createElement("section");

    section.classList.add("section", "skintest__recommend");

    const container = document.createElement("div");

    container.classList.add("container");

    section.append(container);

    const sectionWrapper = document.createElement("div");

    sectionWrapper.classList.add("section__wrapper");

    container.append(sectionWrapper);

    let resultHtml = "";

    if (catalog.morning) {
        resultHtml += getCatalogWithCategories(catalog.morning);
    }

    if (catalog.evening) {
        resultHtml += getCatalogWithCategories(catalog.evening);
    }

    if (catalog.all) {
        resultHtml += getCatalogWithCategories(catalog.all);
    }

    sectionWrapper.innerHTML = resultHtml;

    return section;
}
